import OnboardingScreen from "@/app/onboarding"

export default OnboardingScreen
